import { useLinkProps } from '@tanstack/react-router';
import type { AnchorHTMLAttributes, MouseEventHandler, ReactNode } from 'react';

/**
 * 라우터 링크이되 `aria-current`를 호출자가 정한다. TanStack `Link`는 하위 경로에서도
 * `aria-current="page"`를 붙여, 서브내비·계정 목차의 현재 위치와 겹친다 (D145 ⑤).
 */
export interface ShellLinkProps {
  to: string;
  className?: string;
  activeClassName?: string;
  inactiveClassName?: string;
  current?: AnchorHTMLAttributes<HTMLAnchorElement>['aria-current'];
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  'aria-label'?: string;
  children: ReactNode;
}

export function ShellLink({
  to,
  className,
  activeClassName,
  inactiveClassName,
  current,
  onClick,
  children,
  ...rest
}: ShellLinkProps) {
  const { 'aria-current': _routerCurrent, ...props } = useLinkProps({
    to,
    className,
    activeProps: activeClassName ? { className: activeClassName } : undefined,
    inactiveProps: inactiveClassName ? { className: inactiveClassName } : undefined,
    onClick,
  });

  return (
    <a {...props} {...rest} aria-current={current}>
      {children}
    </a>
  );
}
